import React, { useEffect, useState } from "react";

const IconSelect = (props) => {
  const [IsOpen, setIsOpen] = useState(false);
  const [SelectedOption, setSelectedOption] = useState();

  useEffect(() => {
    if (props.PreselectedOption) {
      setSelectedOption(props.PreselectedOption);
    }
  }, []);

  const selectOption = (Opt) => {
    setSelectedOption(Opt);
    setIsOpen(false);
    props.ChangeEvent();
    if (!IsOpen) {
      document.getElementById(props.Id + "-icon").classList.add("open-icon");
    } else {
      document.getElementById(props.Id + "-icon").classList.remove("open-icon");
    }
  };
  const openOptions = () => {
    setIsOpen(!IsOpen);
    if (!IsOpen) {
      document.getElementById(props.Id + "-icon").classList.add("open-icon");
    } else {
      document.getElementById(props.Id + "-icon").classList.remove("open-icon");
    }
  };
  const close = () => {
    setIsOpen(false);
    document.getElementById(props.Id + "-icon").classList.remove("open-icon");
  };
  const shortenSelectedOption = (Title) => {
    if (window.innerWidth > 450) {
      if (Title.length < 41) {
        return Title;
      } else {
        return Title.slice(0, 41) + "...";
      }
    } else {
      if (Title.length < 31) {
        return Title;
      } else {
        return Title.slice(0, 31) + "...";
      }
    }
  };

  return (
    <div className="iconed-select-wrapper">
      {IsOpen ? <div className="outline" onClick={() => close()}></div> : null}
      <section className="iconed-select" onClick={() => openOptions()}>
        <i className={props.IconClassName + " iconed-select-icon"}></i>

        {SelectedOption ? (
          <p id={"selected-" + props.Id}>
            <input
              hidden
              id={"selected-" + props.Id + "-input"}
              value={SelectedOption.id}
            />
            {shortenSelectedOption(SelectedOption.name)}
          </p>
        ) : (
          <p>{props.Label}</p>
        )}
        <i id={props.Id + "-icon"} className="feather-chevron-down"></i>
      </section>
      {IsOpen ? (
        <section className="options-wrapper">
          {props.Options.map((Opt) => (
            <div
              className={
                SelectedOption !== undefined && Opt.id === SelectedOption.id
                  ? "option-item selected"
                  : "option-item"
              }
              id={Opt.id + "-option"}
              onClick={() => selectOption(Opt)}
            >
              {Opt.name}
              <i className="feather-check"></i>
            </div>
          ))}
        </section>
      ) : null}
    </div>
  );
};
export default IconSelect;
